<template>
    <div>
        <div class=" dropdown-header noti-title">
            <h6 class="text-overflow m-0">Willkommen!</h6>
        </div>
        <a v-if="!isDemo()" href="#" @click.prevent="$store.dispatch('config/change',{customer: true, location: false})"
           class="dropdown-item">
            <i class="ni ni-collection"></i>
            <span class="text-muted text-sm">Organisation: </span><br><p class="text-center mb-0 text-sm "><strong>{{customer}}</strong></p>
        </a>
        <a v-if="!isDemo()" href="#" @click.prevent="$store.dispatch('config/change',{customer: false, location: true})"
           class="dropdown-item">
            <i class="ni ni-pin-3"></i>
            <span class="text-muted text-sm">Standort: </span><p class="text-center mb-0 text-sm "><strong>{{location}}</strong></p>
        </a>
        <router-link v-if="!isDemo()" to="/users/userdata" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>Meine Benutzerdaten</span>
        </router-link>
        <router-link v-if="isOperator" to="/customer/billing" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>Rechnungen & Vertragsdaten</span>
        </router-link>
        <router-link v-if="isService && !isDemo()" to="/users/profiles" class="dropdown-item">
            <i class="fas fa-users"></i>
            <span>Profile</span>
        </router-link>
        <a v-if="isService && !isDemo()" href="#" @click.prevent="$store.dispatch('profiles/setNoActiveProfile')"
           class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Profil wechseln</span>
        </a>
        <div class="dropdown-divider"></div>
        <a href="#" @click.prevent="logout" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
        </a>
    </div>
</template>
<script>


    export default {
        name: 'UserMenu',
        data() {
            return {
                showCustomerModal: false
            }
        },
        created(){
          this.$store.dispatch('customer/getCustomerCollection');
          this.$store.dispatch('location/getLocationCollection');
        },
        computed: {
            isService() {
                return this.$store.getters['authentication/isService'];
            },
            isOperator() {
                return this.$store.getters['authentication/isOperator'];
            },
            customer() {
                return (this.$store.getters['customer/isReady']) ? this.$store.getters['customer/showCustomerByIRI']('/api/customers/'+this.$store.getters['authentication/customer']).name : 'ID: ' + this.$store.getters['authentication/customer'];
            },
            location() {
                return (this.$store.getters['location/isReady'] && this.$store.getters['authentication/location'] !== null && this.$store.getters['authentication/location'] !== '' && typeof this.$store.getters['authentication/location'] !== 'undefined') ? this.$store.getters['location/showLocationByIRI']('/api/locations/'+this.$store.getters['authentication/location']).name : '';
            }
        },
        methods: {
          isDemo() {
            return process.env.VUE_APP_DEMOUSER === this.$store.getters['authentication/email']
          },
            logout() {
                this.$store.dispatch('profiles/setNoActiveProfile').then(() => {
                    this.$store.dispatch('authentication/logout');
                    this.allowMultipleInstances();
                    location.reload();
                });
            }
        }
    }
</script>